export default __webpack_public_path__ + "static/media/1_Still.e33baaa2.jpg";